import {
    FormControl,
    FormField,
    FormItem,
    FormMessage,
} from "ui/components/form";
import { FormLabel } from "components/form";
import { Input } from "ui/components/input";

const BookmarkForm = ({ form, requiredFields }) => {
    return (
        <div className="grid gap-3">
            {/* Name Field */}
            <FormField
                control={form.control}
                name="label"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel required={requiredFields.includes(field.name)}>
                            Name
                        </FormLabel>
                        <FormControl>
                            <Input {...field} />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />

            {/* URL Field */}
            <FormField
                control={form.control}
                name="url"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel required={requiredFields.includes(field.name)}>
                            URL
                        </FormLabel>
                        <FormControl>
                            <Input {...field} type="url" />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />

            {/* Description Field */}
            <FormField
                control={form.control}
                name="description"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel required={requiredFields.includes(field.name)}>
                            Description
                        </FormLabel>
                        <FormControl>
                            <Input {...field} />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
        </div>
    );
};

export default BookmarkForm;